import { render, staticRenderFns } from "./ProductPricesPopup.vue?vue&type=template&id=5c5c2919"
import script from "./ProductPricesPopup.vue?vue&type=script&lang=js"
export * from "./ProductPricesPopup.vue?vue&type=script&lang=js"
import style0 from "./ProductPricesPopup.vue?vue&type=style&index=0&id=5c5c2919&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports